<style>
    .list-enter-active, .list-leave-active {
        transition: all 1s;
    }
    .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
        opacity: 0;
        transform: translateX(30px);
    }
    .alert-box {
        margin-top: 1rem;
        font-size: 16px;
    }
</style>
<template>
    <div>
        <div class="row">
            <div class="col">
                <transition-group name="list" tag="div">
                    <div class="alert alert-success" role="alert" v-for="(message,idx) in successMessage" :key="message">
                        <div class="pull-right" @click="successMessage.splice(idx, 1)"><span class="fa fa-close"></span></div>
                        {{message}}
                    </div>
                </transition-group>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8">
                <h3 class="program-information">PROGRAM INFORMATION</h3>
                <p v-for="user in program.users" :key="user.id">
                    <b>{{program.name}}</b>
					<br />
					<b>{{user.first_name}} {{user.last_name}} | <a class="primaryDark" v-bind:href="'mailto:'+user.email">{{user.email}}</a></b>
					<br />
					<a v-bind:href="$basePath+'/my-programs/details/'+program.id" class="more-information" >More Information <i class="fas fa-caret-right"></i></a>
                </p>
            </div>
            <div class="col-sm-4 text-right">
                <button type="button" class="btn btn-orange-blue" v-on:click="createNewLog" data-toggle="modal" data-target="#activityLogFormModal">
                    Add TA Activity
                </button> 
            </div>
        </div>
        <div id="childcareProgramWrapper" class="tabs-template">
            <ul class="nav nav-tabs" id="childcareProgramTabs" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="provider-activity-tab" data-toggle="tab" href="#provider-activity" role="tab" aria-controls="provider-activity" aria-selected="true">Provider Activity</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="technical-assistance-activity-tab" data-toggle="tab" href="#technical-assistance-activity" role="tab" aria-controls="technical-assistance-activity" aria-selected="false">Technical Assistance Activity</a>
                </li>
            </ul>
            <div>

                <div class="tab-content" id="childcareProgramTabsContent">
                    <div class="tab-pane fade show active p-4" id="provider-activity" role="tabpanel" aria-labelledby="provider-activity-tab">
                        <program-progress 
                            :program="program"
                            :assessments="program.assessments"
                            :modules="modules"
                            :survey-cutoffs="surveyCutoffs"
                            class="mb-4"
                        ></program-progress>

                        <div class="assessments-dash-component">
                            <dashboard-tabs :program="program" :modules="modules" :assessments="program.assessments" :action-plans="program.action_plans">
                                <template #primary="{ module }">
                                    <assessment-actions :module="module" :assessments="assessmentsInModule(module)" v-if="!hideModule(module)"></assessment-actions>
                                    <div v-else class="alert alert-danger alert-box">This program does not meet the criteria for any questions in this assessment. If you feel this is a mistake, please ask the program to review and update the information in their My Account page. 
                                        Please note, to modify their My Account page, they will first need to complete any open self-assessments in other modules.</div>
                                </template>
                                <template #secondary="{ module }">
                                    <div v-if="!hideModule(module)">

                                        <div :class="'border-'+ module.color" class="mx-0 p-4 border-top-0">
                                            <span class="five-steps-number two float-left"></span>
                                            <h3 class="lighter text-orange mb-0">
                                                Plan
                                            </h3>
                                            <action-plan-list :module="module" :action-plans="plansInModule(module.id)" :assessments="assessmentsInModule(module)"></action-plan-list>
                                        </div>
                                        
                                        <div :class="'border-'+ module.color" class="completed-assessments mx-0 p-4 border-top-0 row">
                                            <div class="col-sm-4">
                                                <div class="five-steps-number three float-left"></div>
                                                <h3 class="lighter text-orange ml-2">
                                                    Take Action
                                                </h3>
                                                <a :href="$basePath+'/tips-and-materials/'" class="btn btn-orange-blue text-white btn-sm form-control">
                                                    View Tips &amp; Materials
                                                </a>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="five-steps-number four float-left"></div>
                                                <h3 class="lighter text-orange">
                                                    Learn More
                                                </h3>
                                                <a :href="$basePath+'/provider-trainings/program/' + program.id" class="btn btn-orange-blue text-white btn-sm px-2 form-control">
                                                    View Completed Trainings
                                                </a>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="five-steps-number five float-left"></div>
                                                <h3 class="lighter text-orange">
                                                    Keep It Up
                                                </h3>
                                                <a :href="$basePath+'/self-assessments/'+module.slug+'/new'" class="btn btn-orange-blue text-white btn-sm form-control" v-if="isProgramUser">
                                                    Retake My Assessment
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </dashboard-tabs>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="technical-assistance-activity" role="tabpanel" aria-labelledby="technical-assistance-activity-tab">
                        <activity-log-list 
                            :logs="logs"
                            v-on:editlogentry="setupEditForm($event)"
                        >
                        </activity-log-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import DashboardTabs from '../dashboard_tabs/DashboardTabs'
    import AssessmentActions from '../assessments/AssessmentActions'
    import ProgramProgress from '../programs/ProgramProgress'
    import ActivityLogList from './ActivityLogList'
    import ActivityLogForm from './ActivityLogForm'
    import ActionPlanList from '../action_plans/ActionPlanList'
    import Auth from '../../auth'
    import { mapWritableState, mapActions } from 'pinia'
    import { useConsultantsStore } from './store.js';

    export default {
        name: 'ConsultantProgram',
        components: {
            DashboardTabs,
            AssessmentActions,
            ProgramProgress,
            ActivityLogList,
            ActivityLogForm,
            ActionPlanList
        },
        props: {
            program: {
                required: true,
                type: Object
            },
            modules: {
                required: true,
                type: Array
            },
            types: {
                required: true,
                type: Array
            },
            logAreas: {
                required: true,
                type: Array
            },
            surveyCutoffs: {
                required: true,
                type: Object
            }

        },
        data() {
            return {
                successMessage: [],
                show: false,
                showLogForm: false
            }
        },
        methods:{
            createNewLog() {
                this.resetCurrentLog();
            },
            handleSavedLog($evt) {
                this.getActivityLogs()
                let msg = 'Sucessfully created activity log'
                if(this.currentLog){
                    msg = 'Sucessfully edited activity log'
                }
                this.successMessage.push(msg)
                const msgIdx = this.successMessage.length-1;
                setTimeout(() => {
                    this.successMessage.splice(msgIdx, 1);
                }, 5000);
                this.closeModal('activityLogFormModal');
            },
            setupEditForm(log){
                this.currentLog = log;
                this.showLogForm = true;
            },
            getActivityLogs(){
                axios('/api/activity-log/program/'+this.program.id)
                .then(function(response){
                    this.logs = response.data;
                    for (var i = 0; i < this.logs.length; i++) {
                        this.logs[i].areaString = this.logs[i].areas.map((area) => { 
                            if (area.id == 15) {
                                return area.name + ': '+this.logs[i].areas_other_details
                            }
                            return area.name;
                        }).join(', ')
                    }
                }.bind(this))
                .catch(function(error){
                })
            },
            changeIcon(id){
                var el =  document.getElementById('icon-'+id);
                if(el.classList.contains('fa-plus')){
                    el.classList.remove('fa-plus')
                    el.classList.add('fa-minus')
                }else if (el.classList.contains('fa-minus')){
                    el.classList.remove('fa-minus')
                    el.classList.add('fa-plus')
                }
            },
            plansInModule(moduleId) {
                return (this.program.action_plans) 
                    ? this.program.action_plans.filter((ap) => ap.goal.best_practice.module_id == moduleId) 
                    : [];
            },
            assessmentsInModule(module) {
                return this.program.assessments.filter(assessment => assessment.survey.module_id == module.id)
            },
            hideModule(module) {
                return this.program['age_0-12'] && !this.program['age_2-5'] && !this.program['age_13-24'] && module.id === 1;
            },
            closeModal(modalId) {
                const modal = document.getElementById(modalId);
                modal.classList.remove('show');
                modal.setAttribute('aria-hidden', 'true');

                const modalBackdrop = document.querySelector('.modal-backdrop');
                if (modalBackdrop) {
                    modalBackdrop.remove();
                }

                document.body.classList.remove('modal-open');
            },
            ...mapActions(useConsultantsStore, {
                resetCurrentLog: 'resetLog',
            })
        },
        mounted: function(){
            this.getActivityLogs()
        },
        computed: {
            isProgramUser: function (){
                return Auth.is('program-user')
            },
            ...mapWritableState(useConsultantsStore, {
                currentLog: 'log',
                logs: 'logs'
            }),
        },
        watch: {
            currentLog(to, from) {
                this.getActivityLogs()
            }
        },
    }
</script>